export const contentTableConfig = {
  title: '观看明细',
  propList: [
    {
      prop: 'consumerNickName',
      label: '客户昵称',
      minWidth: '80',
      slotName: 'consumer',
      align: 'left'
    },
    { prop: 'channelName', label: '直播间', minWidth: '80' },
    { prop: 'deptName', label: '所属部门', minWidth: '80' },
    { prop: 'empName', label: '所属员工', minWidth: '80' },
    { prop: 'accessTime', label: '进入时间', minWidth: '80' },
    { prop: 'endTime', label: '退出时间', minWidth: '80' },
    {
      prop: 'newDuration',
      label: '观看时长',
      minWidth: '80',
      slotName: 'duration',
      sortable: 'custom'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
